// import React, { useEffect, useMemo, useState } from "react";
// import Slider from "rc-slider";
// import "rc-slider/assets/index.css";
// import { Modal, Button, Spinner } from "react-bootstrap";

// type Props = {
//   orgNr: string;
//   isOpen: boolean;
//   onClose: () => void;
//   // nuvarande värden från backend (kan vara null om ingen tröskel)
//   initialYellow: number;
//   initialRed: number;
//   initialMinHistoryMonths: number;
//   // spara-funktion från sidan (så vi inte duplicerar API-logik här)
//   onSave: (payload: { limitYellow: number; limitRed: number; minHistoryMonths: number }) => Promise<void>;
// };

// const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));

// const NullReportingThresholdModal: React.FC<Props> = ({
//   orgNr,
//   isOpen,
//   onClose,
//   initialYellow,
//   initialRed,
//   initialMinHistoryMonths,
//   onSave,
// }) => {
//   const [live, setLive] = useState<[number, number]>([initialYellow, initialRed]);
//   const [minHistory, setMinHistory] = useState<number>(initialMinHistoryMonths);

//   const [hasChanged, setHasChanged] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [saveStatus, setSaveStatus] = useState<string | null>(null);

//   useEffect(() => {
//     if (!isOpen) return;

//     setLive([initialYellow, initialRed]);
//     setMinHistory(initialMinHistoryMonths);
//     setHasChanged(false);
//     setSaveStatus(null);
//   }, [isOpen, initialYellow, initialRed, initialMinHistoryMonths]);

//   const railGradient = useMemo(() => {
//     const y = live[0];
//     const r = live[1];
//     return `linear-gradient(
//       to right,
//       #07A235 0%,
//       #07A235 ${y}%,
//       #F5A32D ${y}%,
//       #F5A32D ${r}%,
//       #DC143C ${r}%,
//       #DC143C 100%
//     )`;
//   }, [live]);

//   const handleSliderChange = (value: number | number[]) => {
//     if (!Array.isArray(value)) return;

//     // rc-slider säkerställer ordning, men vi klampar ändå
//     const y = clamp(value[0], 0, 100);
//     const r = clamp(value[1], 0, 100);

//     setLive([y, r]);
//     setHasChanged(true);
//   };

//   const save = async () => {
//     setSaving(true);
//     setSaveStatus(null);
//     try {
//       await onSave({
//         limitYellow: live[0],
//         limitRed: live[1],
//         minHistoryMonths: minHistory,
//       });

//       setSaveStatus("Gränsvärden sparades!");
//       setHasChanged(false);

//       setTimeout(() => {
//         onClose();
//         setSaveStatus(null);
//       }, 900);
//     } catch (e: any) {
//       setSaveStatus(e?.message ? `Fel: ${e.message}` : "Fel vid sparande av gränsvärden.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // --- Pedagogiska exempel (live) ---
//   const exampleMonths = Math.max(12, Number(minHistory) || 12);

//   // välj två exempel som hamnar runt gul/röd. Minst 1 månad.
//   const exYellowZero = Math.max(1, Math.round(exampleMonths * (live[0] / 100)));
//   const exRedZero = Math.max(1, Math.round(exampleMonths * (live[1] / 100)));

//   const pct = (zero: number, months: number) => (months === 0 ? 0 : (zero / months) * 100);

//   const labelForPct = (p: number) => {
//     if (p >= live[1]) return "Röd";
//     if (p >= live[0]) return "Gul";
//     return "OK";
//   };

//   return (
//     <Modal show={isOpen} onHide={onClose} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Inställningar för nollrapportering</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <p className="slider-description">
//           Här ställer du in när leverantören ska <b>flaggas</b> baserat på <b>nollgrad</b> – hur ofta leverantören
//           historiskt rapporterat <b>0 kr</b>.
//           <br />
//           <br />
//           <b>Gul</b> = varning, <b>Röd</b> = kräver uppföljning.
//         </p>

//         <div style={{ marginTop: 14 }}>
//           <Slider
//             range
//             min={0}
//             max={100}
//             allowCross={false}
//             pushable={1}
//             step={1}
//             value={live}
//             onChange={handleSliderChange}
//             marks={{ 0: "0%", 100: "100%" }}
//             handleStyle={[
//               { backgroundColor: "#F5A32D", borderColor: "#F5A32D" },
//               { backgroundColor: "#DC143C", borderColor: "#DC143C" },
//             ]}
//             trackStyle={[{ backgroundColor: "#f8b133" }]}
//             railStyle={{ background: railGradient }}
//           />
//         </div>

//         <div className="threshold-circles">
//           <div className="circle yellow">
//             <p>{live[0]}%</p>
//           </div>
//           <div className="circle red">
//             <p>{live[1]}%</p>
//           </div>
//         </div>

//         <div style={{ display: "grid", gap: 6, marginTop: 14 }}>
//           <label style={{ fontWeight: 600, fontSize: 13 }}>Min historik (månader)</label>
//           <input
//             type="number"
//             min={12}
//             max={60}
//             value={minHistory}
//             onChange={(e) => {
//               setMinHistory(Number(e.target.value));
//               setHasChanged(true);
//             }}
//             style={{ padding: "8px 10px", borderRadius: 10, border: "1px solid #e5e7eb" }}
//           />
//           <div style={{ fontSize: 12, opacity: 0.75 }}>
//             Minst 12 månader. Historiken används för att räkna nollgrad och avgöra om leverantören ska flaggas.
//           </div>

//           <Button
//             className="btn button-cancel"
//             onClick={() => {
//               setLive([20, 40]);
//               setMinHistory(12);
//               setHasChanged(true);
//             }}
//           >
//             Sätt standard (20 / 40)
//           </Button>
//         </div>

//         {/* --- Pedagogisk förklaring + exempel (ingen ny feature, bara copy) --- */}
//         <div
//           style={{
//             marginTop: 16,
//             padding: 12,
//             borderRadius: 12,
//             background: "#f9fafb",
//             border: "1px solid #e5e7eb",
//           }}
//         >
//           <div style={{ fontWeight: 800, marginBottom: 6 }}>Vad betyder trösklarna?</div>

//           <div style={{ fontSize: 13, opacity: 0.9, lineHeight: 1.45 }}>
//             <div>
//               <b>Nollgrad</b> = andel av de senaste <b>{exampleMonths}</b> månaderna där leverantören rapporterat{" "}
//               <b>0 kr</b>.
//             </div>
//             <div style={{ marginTop: 6 }}>
//               Leverantören flaggas som <b>Gul</b> när nollgraden är minst <b>{live[0]}%</b> och som <b>Röd</b> när den är
//               minst <b>{live[1]}%</b>.
//             </div>
//           </div>

//           <div style={{ marginTop: 10, fontSize: 13 }}>
//             <div style={{ fontWeight: 700, marginBottom: 4 }}>Exempel</div>

//             <div style={{ display: "grid", gap: 6 }}>
//               <div>
//                 0 kr i <b>{exYellowZero}</b> av <b>{exampleMonths}</b> månader → nollgrad{" "}
//                 <b>{pct(exYellowZero, exampleMonths).toFixed(0)}%</b> → <b>{labelForPct(pct(exYellowZero, exampleMonths))}</b>
//               </div>

//               <div>
//                 0 kr i <b>{exRedZero}</b> av <b>{exampleMonths}</b> månader → nollgrad{" "}
//                 <b>{pct(exRedZero, exampleMonths).toFixed(0)}%</b> → <b>{labelForPct(pct(exRedZero, exampleMonths))}</b>
//               </div>
//             </div>

//             <div style={{ marginTop: 8, fontSize: 12, opacity: 0.75 }}>
//               Tips: höj trösklarna om du vill flagga färre leverantörer (mer selektivt). Sänk om du vill flagga fler.
//             </div>
//           </div>
//         </div>

//         {saveStatus && (
//           <p
//             style={{
//               color: saveStatus.includes("sparades") ? "green" : "red",
//               marginTop: 12,
//               textAlign: "center",
//             }}
//           >
//             {saveStatus}
//           </p>
//         )}
//       </Modal.Body>

//       <Modal.Footer>
//         <button className="btn button-cancel" onClick={onClose} disabled={saving}>
//           Avbryt
//         </button>

//         <button className="btn" onClick={save} disabled={!hasChanged || saving}>
//           {saving ? (
//             <>
//               <Spinner animation="border" size="sm" style={{ marginRight: 8 }} />
//               Sparar...
//             </>
//           ) : (
//             "Spara ändringar"
//           )}
//         </button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default React.memo(NullReportingThresholdModal);

import React, { useEffect, useMemo, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Modal, Button, Spinner } from "react-bootstrap";

type Props = {
  orgNr: string;
  isOpen: boolean;
  onClose: () => void;

  initialYellow: number;
  initialRed: number;
  initialMinHistoryMonths: number;

  onSave: (payload: { limitYellow: number; limitRed: number; minHistoryMonths: number }) => Promise<void>;
};

const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));

const NullReportingThresholdModal: React.FC<Props> = ({
  orgNr,
  isOpen,
  onClose,
  initialYellow,
  initialRed,
  initialMinHistoryMonths,
  onSave,
}) => {
  const [live, setLive] = useState<[number, number]>([initialYellow, initialRed]);
  const [minHistory, setMinHistory] = useState<number>(initialMinHistoryMonths);

  const [hasChanged, setHasChanged] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    setLive([initialYellow, initialRed]);
    setMinHistory(initialMinHistoryMonths);
    setHasChanged(false);
    setSaveStatus(null);
  }, [isOpen, initialYellow, initialRed, initialMinHistoryMonths]);

  const railGradient = useMemo(() => {
    const y = live[0];
    const r = live[1];
    return `linear-gradient(
      to right,
      #07A235 0%,
      #07A235 ${y}%,
      #F5A32D ${y}%,
      #F5A32D ${r}%,
      #DC143C ${r}%,
      #DC143C 100%
    )`;
  }, [live]);

  const handleSliderChange = (value: number | number[]) => {
    if (!Array.isArray(value)) return;

    const y = clamp(value[0], 0, 100);
    const r = clamp(value[1], 0, 100);

    setLive([y, r]);
    setHasChanged(true);
  };

  const save = async () => {
    setSaving(true);
    setSaveStatus(null);
    try {
      await onSave({
        limitYellow: live[0],
        limitRed: live[1],
        minHistoryMonths: Math.max(12, Number(minHistory) || 12),
      });

      setSaveStatus("Gränsvärden sparades!");
      setHasChanged(false);

      setTimeout(() => {
        onClose();
        setSaveStatus(null);
      }, 900);
    } catch (e: any) {
      setSaveStatus(e?.message ? `Fel: ${e.message}` : "Fel vid sparande av gränsvärden.");
    } finally {
      setSaving(false);
    }
  };

  // --- Kompakt live-exempel ---
  const exampleMonths = Math.max(12, Number(minHistory) || 12);

  // Vi visar 2 exempel nära gul/röd så användaren direkt ser vad de betyder.
  const exYellowZero = Math.max(1, Math.round(exampleMonths * (live[0] / 100)));
  const exRedZero = Math.max(1, Math.round(exampleMonths * (live[1] / 100)));

  const pct = (zero: number, months: number) => (months === 0 ? 0 : (zero / months) * 100);

  const labelForPct = (p: number) => {
    if (p >= live[1]) return "Röd";
    if (p >= live[0]) return "Gul";
    return "OK";
  };

  const yellowExamplePct = pct(exYellowZero, exampleMonths);
  const redExamplePct = pct(exRedZero, exampleMonths);

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Tröskel för nollrapportering</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Kort, tydlig intro */}
        <div className="slider-description" style={{ fontSize: 13, lineHeight: 1.45 }}>
          <div>
            Trösklarna styr när en leverantör ska flaggas baserat på <b>nollgrad</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            <b>Nollgrad</b> = hur många av de senaste månaderna leverantören haft <b>0 kr</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            <b>Gul</b> = varning · <b>Röd</b> = kräver uppföljning
          </div>

          {/* Den här raden brukar minska missförstånd rejält */}
          <div style={{ marginTop: 10, padding: "8px 10px", borderRadius: 10, background: "#f3f4f6" }}>
            <b>Obs:</b> Tröskeln avgör hur “nollig” leverantören är (OK/Gul/Röd). Själva fakturorna/beloppen visas separat per period.
          </div>
        </div>

        {/* Slider */}
        <div style={{ marginTop: 14 }}>
          <Slider
            range
            min={0}
            max={100}
            allowCross={false}
            pushable={1}
            step={1}
            value={live}
            onChange={handleSliderChange}
            marks={{ 0: "0%", 100: "100%" }}
            handleStyle={[
              { backgroundColor: "#F5A32D", borderColor: "#F5A32D" },
              { backgroundColor: "#DC143C", borderColor: "#DC143C" },
            ]}
            trackStyle={[{ backgroundColor: "#f8b133" }]}
            railStyle={{ background: railGradient }}
          />
        </div>

        {/* Visar valda % */}
        <div className="threshold-circles">
          <div className="circle yellow">
            <p>{live[0]}%</p>
          </div>
          <div className="circle red">
            <p>{live[1]}%</p>
          </div>
        </div>

        {/* Min historik */}
        <div style={{ display: "grid", gap: 6, marginTop: 14 }}>
          <label style={{ fontWeight: 700, fontSize: 13 }}>Historik (månader)</label>

          <input
            type="number"
            min={12}
            max={60}
            inputMode="numeric"
            pattern="[0-9]*"
            value={minHistory}
            onChange={(e) => {
              setMinHistory(Number(e.target.value));
              setHasChanged(true);
            }}
            style={{ padding: "8px 10px", borderRadius: 10, border: "1px solid #e5e7eb" }}
          />

          <div style={{ fontSize: 12, opacity: 0.8 }}>
            Ju fler månader, desto stabilare bedömning. Minst 12.
          </div>

          <Button
            className="btn button-cancel"
            onClick={() => {
              setLive([20, 40]);
              setMinHistory(12);
              setHasChanged(true);
            }}
          >
            Sätt standard (20 / 40)
          </Button>
        </div>

        {/* Kompakt “så funkar det”-ruta */}
        <div
          style={{
            marginTop: 14,
            padding: 12,
            borderRadius: 12,
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
          }}
        >
          <div style={{ fontWeight: 800, marginBottom: 6 }}>Snabbt exempel</div>

          <div style={{ fontSize: 13, lineHeight: 1.45 }}>
            <div>
              Om leverantören haft <b>0 kr i {exYellowZero} av {exampleMonths} månader</b> →{" "}
              <b>{yellowExamplePct.toFixed(0)}%</b> → <b>{labelForPct(yellowExamplePct)}</b>
            </div>

            <div style={{ marginTop: 6 }}>
              Om leverantören haft <b>0 kr i {exRedZero} av {exampleMonths} månader</b> →{" "}
              <b>{redExamplePct.toFixed(0)}%</b> → <b>{labelForPct(redExamplePct)}</b>
            </div>

            <div style={{ marginTop: 8, fontSize: 12, opacity: 0.8 }}>
              Tips: Höj trösklar för färre flaggor. Sänk för fler.
            </div>
          </div>
        </div>

        {saveStatus && (
          <p
            style={{
              color: saveStatus.includes("sparades") ? "green" : "red",
              marginTop: 12,
              textAlign: "center",
            }}
          >
            {saveStatus}
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className="btn button-cancel" onClick={onClose} disabled={saving}>
          Avbryt
        </button>

        <button className="btn" onClick={save} disabled={!hasChanged || saving}>
          {saving ? (
            <>
              <Spinner animation="border" size="sm" style={{ marginRight: 8 }} />
              Sparar...
            </>
          ) : (
            "Spara ändringar"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(NullReportingThresholdModal);
